import { createFileRoute } from "@tanstack/react-router";
import { requireWorkstation } from "../../../../../../utils/workstationGuard";
import { lazy, Suspense } from "react";
import Loading from "../../../../../../pages/Loading/Loading";

const HelpViews = lazy(
  () => import("../../../../../../pages/HelpViews/HelpViews")
);

export const Route = createFileRoute(
  "/$lang/_authenticated/help-views/$type/$part"
)({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <HelpViews />
    </Suspense>
  )
});
